import React from 'react'
import Homepage from './Homepage'
import Header from '../Header & Navbar/Header'
import Navbar from '../Header & Navbar/Navbar'


const Home = () => {
  return (
    <>
    <Header />
    <br />
    <Homepage />
    <br />
    <Navbar />
    </>
  )
}

export default Home